/** Concatène des classes en ignorant les valeurs vides. */
export const cn = (...xs: (string | false | null | undefined)[]): string => xs.filter(Boolean).join(' ');
